export default __webpack_public_path__ + "static/media/orderSummary.43f9d621.png";